import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {TilgangsrolleBruker} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {enumInnslag} from "felles-ng2/støttefunksjoner/enumer";

const debug = initDebugger('KreverTilgangsrolleBrukerDirektiv');

type TilgangsrolleBrukerNavn = keyof typeof TilgangsrolleBruker;

/**
 * Rendrer elementet dersom bruker har angitt {@link TilgangsrolleBruker}.
 */
@Directive({
    selector: '[kreverTilgangsrolleBruker]',
})
export class KreverTilgangsrolleBrukerDirektiv {
    private viewOpprettet = false;

    constructor(private kontekst:BrukerkontekstTilbyder, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

    @Input() set kreverTilgangsrolleBruker(brukerRolle: TilgangsrolleBrukerNavn) {
        const harTilgang = this.harTilgang(brukerRolle);
        debug(`har tilgangsrolle '${brukerRolle}' = ${harTilgang}`)

        if (harTilgang && !this.viewOpprettet) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.viewOpprettet = true;
        } else if(!harTilgang && this.viewOpprettet) {
            this.viewContainer.clear();
        }

    }

    private harTilgang(rollenavn: TilgangsrolleBrukerNavn) {
        const tilgangsrolle = enumInnslag<TilgangsrolleBruker>(rollenavn, TilgangsrolleBruker);
        return this.kontekst.autentisertBruker().inneharTilgangsrolle(tilgangsrolle);
    }
}
